var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNftperp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "nftperp-logo-light_svg__\\\\\\\\u0428\\\\\\\\u0430\\\\\\\\u0440_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 605.5 141",
    style: {
      enableBackground: "new 0 0 605.5 141"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".nftperp-logo-light_svg__st1{fill:#000}")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nftperp-logo-light_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.036,
    y1: 119.032,
    x2: 27.31,
    y2: 30.457
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    style: {
      stopColor: "#4a00c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#7500e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#982be3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    style: {
      stopColor: "#f8958e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffda50"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.8 3.2c-37.6 0-68 30.4-68 68s30.4 68 68 68 68-30.4 68-68-30.4-68-68-68zm-23.2 94-11.7 4.2c-2.7 1-5.1-1.2-4.3-4l3.6-14.6c.2-.9 1.3-1.1 1.9-.4l11 13.1c.5.5.2 1.4-.5 1.7zm18.7-6.9L58 93.4c-.4.2-.9 0-1.2-.3L38 72.1c-.2-.3-.3-.6-.2-1l2.4-9.6c.2-.8 1.3-1.1 1.9-.5l24.7 27.5c.4.6.2 1.5-.5 1.8zm30.1 6.4-.4 1.6c-.8 3.2-4.9 4.2-7.1 1.7L46.2 52.2c-1.7-1.9-2.4-4.5-1.8-6.9l.4-2c.6-2.9 4.3-3.9 6.3-1.7l43.2 47.2c2 2.1 2.8 5 2.1 7.9zm6-25.2-2.4 9.6c-.2.8-1.3 1.1-1.9.5L73.5 54.1c-.5-.6-.3-1.5.4-1.7l8.3-3.1c.4-.2.9 0 1.2.3l18.7 21c.3.2.4.6.3.9zm6.2-26.3L105 59.8c-.2.9-1.3 1.1-1.9.4l-11-13.1c-.5-.6-.2-1.5.5-1.7l11.7-4.2c2.7-.9 5.1 1.2 4.3 4z",
    style: {
      fill: "url(#nftperp-logo-light_svg__SVGID_1_)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "nftperp-logo-light_svg__st1",
    d: "M389.2 45c-8.9 0-15.8 3.5-20.1 9v-7.1h-17.3v66.4h17.3V88.4c4.3 5.5 11.2 9 20.1 9 15.3 0 25.9-10 25.9-26.1 0-16.3-10.5-26.3-25.9-26.3zm-4.8 39.1c-5.9 0-11.3-2-15.1-7V65.2c3.9-4.9 9.2-7 15.1-7 9.2 0 14.3 4.8 14.3 12.9 0 8.2-5.1 13-14.3 13zM453.1 44.8c-19.5 0-31.4 10-31.4 26.4s12.1 26.4 32.7 26.4c11.1 0 20.1-2.5 27-8.6l-8.8-9.2c-4.8 3.7-9.5 5.5-17.2 5.5-9.9 0-15.8-3-17.2-10.4h44.5c.4-1 .4-2.1.4-4 .1-17.3-12.4-26.1-30-26.1zm-14.4 20.8c1.9-5.9 7.1-8.6 14.6-8.6 7.4 0 12.1 2.7 13.9 8.4l-28.5.2zM509.6 55.9v-9.1h-17.3v48.8h17.3V72.1c2.6-8 10-12 20.4-12V45.7c-8.6 0-16.3 3.3-20.4 10.2zM575.1 45c-8.9 0-15.8 3.5-20.1 9v-7.1h-17.3v66.4H555V88.4c4.3 5.5 11.2 9 20.1 9 15.3 0 25.9-10 25.9-26.1C601 55 590.4 45 575.1 45zm-4.8 39.1c-5.9 0-11.3-2-15.1-7V65.2c3.9-4.9 9.2-7 15.1-7 9.2 0 14.3 4.8 14.3 12.9-.1 8.2-5.2 13-14.3 13zM185.3 95.6V46.8h17.3v7.7c4.1-6.1 11.4-9.5 20.1-9.5 14.2 0 21.8 9.1 21.8 21.8v28.7h-17.3V68c0-6.3-3.6-10-10.2-10-5.7 0-10.6 2.7-14.3 8.7v28.9h-17.4zM276.7 46.8h19.1V59h-18.6v36.5h-17.3V59.1h-8.6V46.8h8.6c.2-12.4 9.1-18.2 20.9-18.2 4.9 0 11.4 1 15.6 2.9l-2.5 9.8c-3.1-1.4-5.9-2-8.6-2-5.5 0-8.5 2.2-8.5 6.2v1.3zM344 92.7c-4.4 3-11.3 4.8-17.2 4.8-11.1 0-19.5-6.1-19.5-17.9V59.1h-8.6V46.8h8.6V35.5h17.3v11.4h18.7v12.2h-18.7v17.6c0 4.4 3.3 7 7.9 7 2.9 0 5.6-1 8.4-2.3l3.1 11.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftperp);
export default __webpack_public_path__ + "static/media/nftperp.c923bb7815207e4d77e3958cacc8984d.svg";
export { ForwardRef as ReactComponent };